// extracted by mini-css-extract-plugin
export var pageSection = "PageSection-module--page-section--wsQkP";
export var topSection = "PageSection-module--top-section--3K1q_ PageSection-module--page-section--wsQkP";
export var noPad = "PageSection-module--no-pad--FwS2E";
export var slim = "PageSection-module--slim--1o7fF";
export var moderate = "PageSection-module--moderate--3VJbd";
export var curveTop = "PageSection-module--curve-top--2tiSw";
export var curveBottom = "PageSection-module--curve-bottom--3MVA9";
export var width = "PageSection-module--width--26ZB0";